<template>
	<section class="section-main">
      <div class="container ptb-100  sm-prl-30">
        <div class="row justify-content-between align-items-center">
          <div class="col-md-12 col-lg-6 text-center">
            <!--<img class="border-img" src="/img/office.png" alt="Our Office">-->
            <my-video :sources="video.sources" :options="video.options"></my-video>
          </div>
          <div class="col-md-12 col-lg-6 prl-60 sm-prl-15 md-mt-100">
            <h3 class="mb-30">{{ $t('about.slogan') }}</h3>
            <p>{{ $t('about.i1') }}</p>
            <p>{{ $t('about.i2') }}</p>
			<p>{{ $t('about.i3') }}</p>
          </div>
        </div>
      </div>
    </section>
</template>
<script>
import myVideo from 'vue-video'

export default {
  name: 'Intro',
  data () {
    return {
      video: {
        sources: [{
            src: 'https://outin-ab585c613abc11ec9be600163e1a65b6.oss-cn-shanghai.aliyuncs.com/sv/fadb70a-17cd9639773/fadb70a-17cd9639773.mp4',
            type: 'video/mp4'
        }],
        options: {
            autoplay: true,
            volume: 0.6,
            poster: this.API_PREFIX + '/img/er-cover.jpeg'
        }
      }
    }
  },
  components: {
    myVideo
  }
}
</script>